/* eslint-disable typescript-sort-keys/string-enum */
// Avoiding to mess with the logical order when presented in the editor
var BytesSizeUnit;
(function (BytesSizeUnit) {
    BytesSizeUnit["BYTES"] = "B";
    BytesSizeUnit["KILOBYTES"] = "KB";
    BytesSizeUnit["MEGABYTES"] = "MB";
    BytesSizeUnit["GIGABYTES"] = "GB";
    BytesSizeUnit["TERABYTES"] = "TB";
})(BytesSizeUnit || (BytesSizeUnit = {}));
export { BytesSizeUnit, };
//# sourceMappingURL=bytes-size-unit.js.map